import { css } from '@emotion/core'
import { colors, measures } from 'styles/variables'

const { unit } = measures

export const footer = css`
  display: flex;

  justify-content: center;

  background-color: ${colors.oranges.orange1};

  min-height: ${8 * unit}px;
`

export const menuContainer = css`
  display: flex;

  justify-content: space-between;
  align-items: center;
`

export const menu = css`
  list-style: none;
`

export const link = css`
  color: ${colors.black100};

  cursor: pointer;

  text-decoration: underline;

  :hover {
    color: ${colors.white100};
  }
`

export const menuItem = css`
  display: block;
  margin-bottom: ${unit}px;

  ${link}
`

export const copyright = css`
  text-align: center;
`
